import * as o from "react";
import { createTheme as t } from "@aws-amplify/ui";
import { AmplifyContext as e } from "../components/ThemeProvider/AmplifyContext.js";

var m = function m(o) {
  return void 0 === o || void 0 === o.theme ? t() : o.theme;
},
    r = function r() {
  var t = o.useContext(e);
  return m(t);
};

export { m as getThemeFromContext, r as useTheme };